module.exports = __webpack_public_path__ + "img/Unidad10-5.77044c27.png";